import React, {useState} from 'react';
import Navigation from "../partials/Navigation";
import {Helmet} from "react-helmet";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsExporting from 'highcharts/modules/exporting';
import { useTranslation } from "react-i18next";

const CostCalculator = () => {

    const [employeesNum, setEmployeesNum] = useState(100);
    const [employeeCost, setEmployeeCost] = useState(520000);
    const [factor, setFactor] = useState('');
    const [factorNum, setFactorNum] = useState(15);

    const [translation] = useTranslation("translations");

    const totalCost = employeesNum * employeeCost;

    let lossPercent = 0.09;

    if ( factor === 'lack of sleep' ) {
        lossPercent = 0.12;
    }

    let productivityLoss = 0;
    let productivityLossPercentage = 0;

    if ( factorNum > 0 ) {
        productivityLoss = parseInt( ((totalCost*factorNum)/100)*lossPercent , 10 );
    }

    if ( productivityLoss > 0 ) {
        productivityLossPercentage = (productivityLoss/totalCost)*100;
    }

    const productivityPrecentage = 100 - productivityLossPercentage;

    const options = {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
            backgroundColor: "rgba(255,255,255,0)"
        },
        title: {
            text: 'Kostnad summa'
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    formatter: function() {

                        const valNum = parseInt( ((totalCost)/100)*this.percentage , 10 );

                        return `${new Intl.NumberFormat('sv-SV', { maximumSignificantDigits: 3 }).format(valNum)} kr`;
                    },
                },
                showInLegend: true
            }
        },
        series: [{
            name: 'Produktivitet',
            colorByPoint: true,
            data: [{
                name: translation("productivity_text"),
                y: productivityPrecentage,
                sliced: true,
                selected: true,
                color: "#b99353"
            }, {
                name: translation("productivity_loss"),
                y: productivityLossPercentage,
                color: "#B23722"
            }]
        }]
    };

    if (typeof Highcharts === 'object') {
        HighchartsExporting(Highcharts)
    }

    return(
        <div className="main-wrapper">
            <Helmet>
                <title >Kostnadskalkylator</title>
                <meta name="description" content="" />
            </Helmet>
            <Navigation />

            <div className="page-content-wrap">
                <HorizontalNav title="Vad kostar ohälsan ert företag?" />

                <div className="pt-5 pt-lg-0 page-content-inner" style={{maxWidth: "1440px"}}>
                    <div className="row g-0">
                        <div className="col-12 pt-5 px-3">

                            <div className="row">
                                <div className="col-12 col-lg-7 pe-lg-5 border-end">

                                    <div className="mb-4 mb-lg-5">
                                        <h4>Beräkningsfaktor</h4>
                                        <div className="d-flex mt-3">
                                            <button type='button' className={`btn rounded-0 shadow-sm me-2 ${ factor === 'stress' ? 'btn-primary text-white' : 'btn-light bg-white'}`} onClick={() => setFactor('stress')}>Stress</button>
                                            <button type='button' className={`btn rounded-0 shadow-sm me-2 ${ factor === 'lack of sleep' ? 'btn-primary text-white' : 'btn-light bg-white'}`} onClick={() => setFactor('lack of sleep')}>Sömnbrist</button>
                                        </div>
                                    </div>

                                    <div className="mb-4 mb-lg-5">
                                        <label htmlFor="no_of_employees" className="form-label h4">
                                            <span>Antal anställda</span>
                                            <span className="d-inline-block px-2 bg-primary rounded-0 ms-2 text-white fw-bold">{new Intl.NumberFormat('sv-SV', { maximumSignificantDigits: 3 }).format(employeesNum)}</span>
                                        </label>
                                        <input type="range" className="form-range" min="1" max="6000" step="1" id="no_of_employees" value={employeesNum} onChange={(e) => setEmployeesNum(e.target.value)} />
                                    </div>

                                    { factor &&
                                        <div className="mb-4 mb-lg-5">
                                            <label htmlFor="factor_num" className="form-label h4">
                                                <span>Andel medarbetare med {`${ factor === 'stress' ? 'hög stressnivå' : 'sömnbrist'}`}</span>
                                                <span className="d-inline-block px-2 bg-primary rounded-0 ms-2 text-white fw-bold">{factorNum}%</span>
                                            </label>
                                            <input type="range" className="form-range" min="0" max="100" step="1" id="factor_num" value={factorNum} onChange={(e) => setFactorNum(e.target.value)} />
                                        </div>
                                    }

                                    <div className="mb-4 mb-lg-5">
                                        <label htmlFor="employee_cost" className="form-label h4">
                                            <span>Årskostnad per medarbetare</span>
                                            <span className="d-inline-block px-2 bg-primary rounded-0 ms-2 text-white fw-bold">{new Intl.NumberFormat('sv-SV', { maximumSignificantDigits: 3 }).format(employeeCost)} kr</span>
                                        </label>
                                        <input type="range" className="form-range" min="180000" max="2000000" step="1" id="employee_cost" value={employeeCost} onChange={(e) => setEmployeeCost(e.target.value)} />
                                        <div id="emailHelp" className="form-text">Totala beloppet av medelårslön + sociala avgifter/ löneskatt + pension + friskvård + försäkringar + overheadkostnader etc. För en uppskattad total Årskostnad per anställd ta medelårslönen multiplicerat med två.</div>
                                    </div>
                                

                                </div>
                                <div className="col-12 col-lg-5 ps-lg-4">

                                    { factor &&
                                        <div className="row">
                                            <div className="col-12 mb-2 pb-2 mb-lg-3 pb-lg-5 border-bottom">
                                                <HighchartsReact
                                                    highcharts={Highcharts}
                                                    options={options}
                                                />
                                            </div>
                                        </div>
                                    }
                                    
                                    <div className="row align-items-center">
                                        <div className="col-8">
                                            <h5>Summa värdet av arbete</h5>
                                        </div>
                                        <div className="col-4">
                                            <div className="d-flex w-100">
                                                <span className='flex-grow-1'>=</span>
                                                <span className="d-inline-block rounded-0 ms-2 text-primary fw-bold h5">{new Intl.NumberFormat('sv-SV', { maximumSignificantDigits: 3 }).format(totalCost)} kr</span>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    { factor &&
                                        <>
                                            <div className="row align-items-center">
                                                <div className="col-8">
                                                    <h5>{translation("productivity_loss")} vid {`${ factor === 'stress' ? 'hög stressnivå' : 'sömnbrist'}`}</h5>
                                                </div>
                                                <div className="col-4">
                                                    <div className="d-flex w-100">
                                                        <span className='flex-grow-1'>=</span>
                                                        <span className="d-inline-block rounded-0 ms-2 text-sy-red fw-bold h5">{new Intl.NumberFormat('sv-SV', { maximumSignificantDigits: 3 }).format(productivityLoss)} kr</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row align-items-center">
                                                <div className="col-8">
                                                    <h5 className='mt-2 pt-2'>{translation("productivity_text")}</h5>
                                                </div>
                                                <div className="col-4 border-top border-bottom mt-2 pt-2">
                                                    <div className="d-flex w-100 justify-content-end">
                                                        <span className="d-inline-block rounded-0 ms-2 text-primary fw-bold h5">{new Intl.NumberFormat('sv-SV', { maximumSignificantDigits: 3 }).format(totalCost-productivityLoss)} kr</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default CostCalculator;